// vg-binding: P7.D-70
//
// apps/vendor/src/features/print-queue/KanbanBoard.tsx
//
// Phase 7 Wave 14 Task 54 — horizontal Kanban board of printer columns.

import { useTranslation } from 'react-i18next';

import { PrinterColumn } from './PrinterColumn.js';
import type { PrintQueueAssignment, PrintQueueColumn } from './api.js';

interface KanbanBoardProps {
  columns: PrintQueueColumn[];
  onDropAssignment: (printerId: string, assignmentId: string) => void;
  onOpenDetail?: (assignment: PrintQueueAssignment) => void;
}

export function KanbanBoard({
  columns,
  onDropAssignment,
  onOpenDetail,
}: KanbanBoardProps): JSX.Element {
  const { t } = useTranslation('orders');
  if (columns.length === 0) {
    return (
      <div
        data-testid="print-queue-kanban-board"
        className="rounded-xl border border-dashed border-pw-border bg-pw-surface px-6 py-10 text-center text-sm text-pw-text-muted"
      >
        {t('printQueue.board.emptyColumns')}
      </div>
    );
  }
  return (
    <div
      data-testid="print-queue-kanban-board"
      className="flex gap-4 overflow-x-auto pb-4"
    >
      {columns.map((c) => (
        <PrinterColumn
          key={c.printer_id}
          column={c}
          onDropAssignment={onDropAssignment}
          {...(onOpenDetail ? { onOpenDetail } : {})}
        />
      ))}
    </div>
  );
}

export default KanbanBoard;
